import { render, staticRenderFns } from "./DestinationOfRates.vue?vue&type=template&id=72697be8"
import script from "./DestinationOfRates.vue?vue&type=script&lang=js"
export * from "./DestinationOfRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports